import React from 'react';
import { Container, Typography, Grid, Box } from '@mui/material';
import { motion } from 'framer-motion';
import './UIUXTechStack.css';

const technologies = [
  {
    category: "Design Tools",
    description: "Industry-standard tools for creating stunning user interfaces and experiences",
    tools: [
      {
        name: "Figma",
        icon: "/assets/tech-logos/figma.svg",
        description: "Collaborative interface design tool"
      },
      {
        name: "Adobe XD",
        icon: "/assets/tech-logos/adobe-xd.svg",
        description: "Vector-based design tool"
      },
      {
        name: "Sketch",
        icon: "/assets/tech-logos/sketch.svg",
        description: "Digital design for Mac"
      },
      {
        name: "Adobe Photoshop",
        icon: "/assets/tech-logos/photoshop.svg",
        description: "Image editing and design"
      },
      {
        name: "Adobe Illustrator",
        icon: "/assets/tech-logos/illustrator.svg",
        description: "Vector graphics editor"
      },
      {
        name: "InVision",
        icon: "/assets/tech-logos/invision.svg",
        description: "Digital product design platform"
      }
    ]
  },
  // {
  //   category: "Prototyping & Testing",
  //   description: "Tools for creating interactive prototypes and gathering user feedback",
  //   tools: [
  //     {
  //       name: "Framer",
  //       icon: "/assets/tech-logos/framer.svg",
  //       description: "Interactive design tool"
  //     },
  //     {
  //       name: "Maze",
  //       icon: "/assets/tech-logos/maze.svg",
  //       description: "Rapid testing platform"
  //     },
  //     {
  //       name: "Hotjar",
  //       icon: "/assets/tech-logos/hotjar.svg",
  //       description: "User behavior analytics"
  //     },
  //     {
  //       name: "UsabilityHub",
  //       icon: "/assets/tech-logos/usabilityhub.svg",
  //       description: "Remote user testing"
  //     },
  //     {
  //       name: "Miro",
  //       icon: "/assets/tech-logos/miro.svg",
  //       description: "Collaborative whiteboarding"
  //     },
  //     {
  //       name: "Zeplin",
  //       icon: "/assets/tech-logos/zeplin.svg",
  //       description: "Design handoff and collaboration"
  //     }
  //   ]
  // }
];

const UIUXTechStack = () => {
  return (
    <section className="uiux-tech-stack">
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="tech-stack-header"
        >
          <Typography variant="h2" className="tech-stack-title">
            Our Technology Stack
          </Typography>
          <Typography variant="subtitle1" className="tech-stack-subtitle">
            We use cutting-edge design and prototyping tools to create exceptional user experiences
          </Typography>
        </motion.div>

        <Grid container spacing={4}>
          {technologies.map((category, index) => (
            <Grid item xs={12} md={6} key={index}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
              >
                <Box className="tech-category">
                  <Typography variant="h5" className="uiux-category-title">
                    {category.category}
                  </Typography>
                  <Typography variant="body1" className="uiux-category-description">
                    {category.description}
                  </Typography>
                  <Grid container spacing={2} className="tech-grid">
                    {category.tools.map((tool, toolIndex) => (
                      <Grid item xs={6} sm={4} key={toolIndex}>
                        <motion.div
                          className="tech-item"
                          whileHover={{ y: -5 }}
                          transition={{ duration: 0.2 }}
                        >
                          <img
                            src={tool.icon}
                            alt={tool.name}
                            className="tech-icon"
                          />
                          <Typography variant="subtitle2" className="tech-name">
                            {tool.name}
                          </Typography>
                        </motion.div>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </section>
  );
};

export default UIUXTechStack; 